// extracted by mini-css-extract-plugin
export var logo = "_54-2";
export var logoWrapper = "_54-1";
export var strip = "_54-0";